import {
  DrawerBody,
  Grid,
  GridItem,
  Divider,
  Box,
  HStack,
  DrawerFooter,
  Button,
  Text,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import FormInput from "../input";
import { Option } from "../../utils/types/props.dropdown";
import { measurmentFormik } from "../../utils/formik/measurment";
import { useFormik } from "formik";
import { color } from "../../utils/theme";
import {
  MeasurementType,
  MeasurementTypes,
} from "../../utils/types/measurment";
import Select from "react-select";

interface MeasurementProps {
  changeIdea?: string;
  measurementType: MeasurementTypes;
  dataType: Option[];
  frequency: Option[];
  onSubmit: (addedMeasurment: MeasurementType) => void;
  onCancel: () => void;
  onUpdated: (updatedMeasurment: MeasurementType) => void;
  measurement?: MeasurementType;
}

const Measurement = (props: MeasurementProps) => {
  const formik = useFormik({
    initialValues: {
      ...measurmentFormik.initialValues,
      measurmentType: props.measurementType,
    },
    onSubmit: (values) => {
      console.log("values: ", values);
      console.log("errors: ", formik.errors);

      setIsSubmitting(true);

      setTimeout(() => {
        props.onSubmit(values);
        formik.resetForm();
        setIsSubmitting(false);
      }, 3000);
    },
  });
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [showChangeIdea, setShowChangeIdea] = useState(false);
  const [selectedDataType, setSelectedDataType] = useState<string>(
    "" as string
  );

  useEffect(() => {
    if (props.measurement) {
      formik.setValues({
        ...formik.values,
        ...props.measurement,
      });
    }
    console.log("formik.values: ", props.measurement);
  }, [props.measurement]);

  useEffect(() => {
    console.log("Props to measurement component: ", props.measurementType);
  }, []);

  return (
    <>
      <DrawerBody height={"100%"}>
        <Grid templateColumns="repeat(2, 1fr)" rowGap={5} gap={4} w={"100%"}>
          <GridItem colSpan={2}>
            <Text fontSize="lg" textAlign={"left"}>
              {props.changeIdea}
            </Text>
            <Divider my={3} />
          </GridItem>

          <GridItem w="100%" colSpan={2}>
            <FormInput
              name="name"
              isRequired={true}
              value={formik.values.name}
              errorMessage={formik.errors.name as string}
              label="Measurment Name"
              type="text"
              id="name"
              onChange={(event) => {
                formik.setFieldValue("name", event.target.value);
              }}
            />
          </GridItem>
          <GridItem w="100%" colSpan={!showChangeIdea ? 2 : 1}>
            <FormControl style={{ width: "100%" }}>
              <FormLabel
                display={"flex"}
                mb={0}
                fontWeight={"500"}
                color={color.text}
              >
                Data Type
                <Text color={"red"} mx={1} fontSize={24}>
                  *
                </Text>
              </FormLabel>

              <Select
                placeholder=" "
                options={props.dataType}
                onChange={(value) => {
                  if (value) {
                    formik.setFieldValue("dataType", value?.label);
                    formik.setFieldValue("calculation", "");
                    setSelectedDataType(value?.value.toString());
                  }
                }}
              />

              <Text
                marginY={3}
                fontWeight={"normal"}
                color={"red"}
                fontSize={13}
              >
                {formik.errors.dataType?.toString()}
              </Text>
            </FormControl>
          </GridItem>

          {formik.values.dataType === "Percentage" && (
            <>
              <GridItem
                colSpan={2}
                h={"fit-content"}
                w={"100%"}
                borderRadius={4}
                borderWidth={1}
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-start"}
                p={5}
              >
                <Box
                  textAlign={"left"}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={2}
                  w={"100%"}
                  justifyContent={"flex-start"}
                  justifySelf={"flex-start"}
                  alignSelf={"flex-start"}
                >
                  <Text
                    textAlign={"left"}
                    display={"flex"}
                    flexDirection={"row"}
                    fontSize={16}
                    color={color.text}
                    fontWeight={"normal"}
                  >
                    {selectedDataType === "Percentage"
                      ? "Enter Numerator and Denominator"
                      : "Enter Number"}
                    <Text fontSize={22} ml={4} color={"red"}>
                      *
                    </Text>
                  </Text>
                  {formik.values.dataType === "Percentage" ? (
                    <>
                      <HStack spacing={6} w={"100%"}>
                        <FormInput
                          name="numerator"
                          isRequired={false}
                          value={formik.values.numerator}
                          errorMessage={formik.errors.numerator as string}
                          placeholder="Enter Numerator"
                          label=""
                          type="text"
                          id="numerator"
                          onChange={(event) => {
                            formik.setFieldValue(
                              "numerator",
                              event.target.value
                            );
                          }}
                          style={{ width: 200 }}
                        />
                        <Text fontSize={22} fontWeight="500">
                          /
                        </Text>

                        <FormInput
                          name="denominator"
                          isRequired={false}
                          value={formik.values.denominator}
                          errorMessage={formik.errors.denominator as string}
                          placeholder="Denominator"
                          label=""
                          type="text"
                          id="denominator"
                          onChange={(event) => {
                            formik.setFieldValue(
                              "denominator",
                              event.target.value
                            );
                          }}
                        />
                      </HStack>
                    </>
                  ) : (
                    <FormInput
                      name="numeric"
                      isRequired={false}
                      value={formik.values.numericValue}
                      errorMessage={formik.errors.numericValue}
                      placeholder="Enter Number Value"
                      label=""
                      type="text"
                      id="numerical value"
                      onChange={(e) => {
                        formik.setFieldValue("numericValue", e.target.value);
                      }}
                    />
                  )}
                </Box>
              </GridItem>
            </>
          )}

          <GridItem colSpan={2} w="100%">
            <HStack spacing={4}>
              <GridItem w="100%">
                <FormControl style={{ width: "100%" }}>
                  <FormLabel
                    display={"flex"}
                    mb={0}
                    fontWeight={"500"}
                    color={color.text}
                  >
                    Frequency
                    <Text color={"red"} mx={1} fontSize={24}>
                      *
                    </Text>
                  </FormLabel>

                  <Select
                    placeholder=" "
                    options={props.frequency}
                    onChange={(value) => {
                      if (value) {
                        formik.setFieldValue("frequency", value?.label);
                      }
                    }}
                  />
                  <Text
                    marginY={3}
                    fontWeight={"normal"}
                    color={"red"}
                    fontSize={13}
                  >
                    {formik.errors.frequency as string}
                  </Text>
                </FormControl>
              </GridItem>
              <GridItem w="100%">
                <FormInput
                  name="target"
                  isRequired={true}
                  value={formik.values.target}
                  errorMessage={formik.errors.target as string}
                  label="Target"
                  type="number"
                  id="target"
                  onChange={(event) => {
                    formik.setFieldValue("target", event.target.value);
                  }}
                />
              </GridItem>
              <GridItem w="100%">
                <FormInput
                  name="baseline"
                  isRequired={true}
                  value={formik.values.baseline}
                  errorMessage={formik.errors.baseline as string}
                  label="Baseline"
                  type="number"
                  id="baseline"
                  onChange={(event) => {
                    formik.setFieldValue("baseline", event.target.value);
                  }}
                />
              </GridItem>
            </HStack>
          </GridItem>
          <GridItem
            colSpan={2}
            w="100%"
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"flex-end"}
            alignContent={"flex-end"}
          >
            <Divider />
            <HStack spacing={4} mt={5}>
              <Button
                colorScheme="gray"
                size={"md"}
                color={"gray.500"}
                w={200}
                variant="outline"
                fontWeight={"normal"}
                onClick={() => {
                  props.onCancel();
                }}
              >
                Cancel
              </Button>

              {props.measurement ? (
                <Button
                  isLoading={isSubmitting}
                  colorScheme="blue"
                  variant="solid"
                  size={"md"}
                  w={200}
                  fontWeight={"normal"}
                  onClick={() => {
                    formik.handleSubmit();
                    setTimeout(() => {
                      if (formik.isValid) {
                        setIsSubmitting(true);
                        setTimeout(() => {
                          props.onUpdated(formik.values);
                          formik.resetForm();
                          setIsSubmitting(false);
                        }, 3000);
                      } else {
                        console.log("Form is not valid: ", formik.errors);
                      }
                    }, 3000);
                  }}
                >
                  Update
                </Button>
              ) : (
                <Button
                  isLoading={isSubmitting}
                  colorScheme="blue"
                  variant="solid"
                  size={"md"}
                  w={200}
                  fontWeight={"normal"}
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                >
                  Add
                </Button>
              )}
            </HStack>{" "}
          </GridItem>
        </Grid>
      </DrawerBody>

      <DrawerFooter pr={15} w={"95%"} bg={"transparent"}></DrawerFooter>
    </>
  );
};

export default Measurement;
